import { Alert } from 'react-native';
import { Store } from 'redux';
import { RootState } from 'store/types';
import wait from 'modules/utils/wait';
import { logout } from '../authentication/actions';

// Naming things is hard
export const createRefreshInterceptorAlertManager = () => {
  let alertIsDisplaying = false;

  return {
    logoutAndAlert(store: Store<RootState>) {
      if (alertIsDisplaying) {
        return;
      }

      store.dispatch(logout());
      alertIsDisplaying = true;

      wait(150).then(() =>
        Alert.alert('Your session has timed out', 'Please log in again to continue', [
          {
            text: 'OK',
            onPress: () => {
              alertIsDisplaying = false;
            }
          }
        ])
      );
    }
  };
};

const interceptorRefreshTokenManager = createRefreshInterceptorAlertManager();

export default interceptorRefreshTokenManager;
